










import { Component, Vue, Watch } from 'vue-property-decorator'
import TheHeader from '@core/components/header/TheHeader.vue'
import TheFooter from '@core/components/TheFooter.vue'
import NewBusiness from '@core/components/header/assets/new_business.svg'
import { IProjectInfo } from '@master/config/IProjectInfo'
import AppLoader from '@core/components/AppLoader.vue'
import { inject } from 'inversify-props'
import { UIService } from '@core/services/UIService'
import { SharedVariable } from '@core/model/SharedVariable'
import API from '@core/services/API'
import { IProjectSettings, Theme } from '@master/config/IProjectSettings'
import { UIOptions } from '@core/model/UIOptions'

@Component({
  components: {
    TheHeader,
    TheFooter,
    AppLoader
  }
})
export default class App extends Vue {
  uiService = new UIService()
  uIOptions = new UIOptions()

  @inject()
  private sharedVariable: SharedVariable

  @inject()
  private $api: API

  @inject()
  private projectInfo: IProjectInfo

  @inject()
  private projectSettings: IProjectSettings

  private theme: Theme = 'Classic'

  async created () {
    // inject uiService here and set to sharedVariable to gain reactivity,
    // else the loading spinner wont show when added loading tasks
    this.sharedVariable.uiService = this.uiService
    const sysInfo = await this.$api.system.information()
    this.sharedVariable.sysInfo = sysInfo
    this.sharedVariable.options = this.uIOptions
    this.theme = this.projectSettings?.theme || this.theme // if theme is not set, default to 'classic'
  }

  get currentUser () {
    return this.$store.getters.currentUser
  }

  get customHeaders () {
    return [
      {
        disable: !this.currentUser.isSuperUser,
        icon: NewBusiness,
        href: '/live/policy-list',
        label: 'NBR'
      }
    ]
  }

  @Watch('$route')
  updateTitle (to) {
    document.title = to.meta.title || this.projectInfo.brandName
  }
}
